import * as React from 'react';
// @ts-expect-error
import type {SelectBaseProps} from 'react-select';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {FontStyle} from '../../../types';

import {FONT_OPTIONS} from './constants';

type FontOption = {
    value: {
        name: string;
        fontFamily: string;
    };
    label: string;
};

export type Props = SelectBaseProps & {
    value: FontStyle;
    onChange: (value: string) => void;
    pickerRef: any;
};

export function FormFontPicker(props: Props) {
    // isMulti and isClearable throw a flow error on Select Picker Generic
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {pickerRef, isMulti, isClearable, onBlur, value, ...restProps} = props;

    const options = FONT_OPTIONS;

    const selectedValue = options.find((option) => option.value.name === value.name);

    function formatOptionLabel(option: FontOption) {
        return <div style={{fontFamily: option.value.fontFamily}}>{option.label}</div>;
    }

    return (
        <SelectPickerGeneric
            {...restProps}
            value={selectedValue}
            ref={pickerRef}
            // @ts-expect-error
            onChange={(option) => {
                props.onChange(option.value);
            }}
            options={options}
            isSearchable={false}
            formatOptionLabel={formatOptionLabel}
        />
    );
}
